import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class BannerService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v1-banner'] = environment.host('v1-banner');
    }

    uploadNewBanner(file: File, name: String, link: String, active: boolean, filters: string[]): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('data', JSON.stringify({
            name: name,
            link: link,
            active: active,
            filters: filters
        }));
        return this.client.request('POST', `${this.host['v1-banner']}/v1/banner`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.uploadNewBanner.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.uploadNewBanner.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    uploadNewBannerLocale(bannerId: number, file: File, locale: String, link: String): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('data', JSON.stringify({
            locale: locale,
            link: link
        }));
        return this.client.request('POST', `${this.host['v1-banner']}/v1/banner/${bannerId}/locale`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.uploadNewBannerLocale.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.uploadNewBannerLocale.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateBanner(bannerId: number, banner: any): Observable<any> {
        return this.client.request('PUT', `${this.host['v1-banner']}/v1/banner/${bannerId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: {
                name: banner.name,
                active: banner.active,
                link: banner.link,
                locales: banner.locales.map((locale: any) => ({
                    locale: locale.locale,
                    link: locale.link,
                    url: locale.url
                })),
                filters: banner.filters
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.updateBanner.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.updateBanner.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteBanner(bannerId: number): Observable<any> {
        return this.client.request('DELETE', `${this.host['v1-banner']}/v1/banner/${bannerId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.deleteBanner.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.deleteBanner.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteBannerLocale(bannerId: number, locale: string): Observable<any> {
        return this.client.request('DELETE', `${this.host['v1-banner']}/v1/banner/${bannerId}/locale/${locale}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.deleteBannerLocale.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.deleteBannerLocale.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getAdminBanners(): Observable<any> {
        return this.client.request('GET', `${this.host['v1-banner']}/v1/banner/admin`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.getAdminBanners.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.getAdminBanners.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getBanners(filter: string | null = null): Observable<any> {
        const params: any = {};
        if (filter) {
            params.filter = filter;
        }
        return this.client.request('GET', `${this.host['v1-banner']}/v1/banner`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            params: params
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('BannerService.getBanners.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('BannerService.getBanners.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
